import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  MdButton,
  MdContent,
  MdTabs,
  MdField,
  MdIcon,
  MdApp,
  MdCard,
  MdToolbar,
  MdList,
  MdDrawer,
  MdSwitch
} from "vue-material/dist/components";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdContent);
Vue.use(MdTabs);
Vue.use(MdIcon);
Vue.use(MdApp);
Vue.use(MdCard);
Vue.use(MdToolbar);
Vue.use(MdList);
Vue.use(MdDrawer);
Vue.use(MdSwitch);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
